import React from 'react';
import cx from 'classnames';
import { Text } from '../../../../../../ui-kit';

function InternalCreditsSummary({
  usedCredits,
  selectedTeamId,
  workspaceRecurringBalance,
  originalRecurringMonthly,
  allTeamsBalances,
  workspaceTopUpCredits,
  originalTopUp,
  bufferOwed,
  wsBufferLimit,
  workspaceThisMonthOnlyBalance,
  originalThisMonthOnly,
  workspaceRecurringDelta,
  workspaceThisMonthOnlyDelta














}) {
  const { usageOfThisMonthOnlyCredits, usageOfWorkspaceCredits, usageOfTopUpCredits } = usedCredits;

  return (
    <div className="detailed-view">
      <div className="detailed-view__block">
        <div>
          <Text heading4 noMargin>Current Workspace Balance</Text>
          <Text label>Renewable and temporary credits that are part of your subscription</Text>
        </div>
        <div className="detailed-view__block__item">
          <Text noMargin>Recurring Monthly</Text>
          <div>
            <Text heading5 noMargin>
              <span
                className={cx({
                  'detailed-view__block__item__added-credits': workspaceRecurringDelta <= 0,
                  'detailed-view__block__item__subtracted-credits': workspaceRecurringDelta > 0
                })}
                data-testid="workspace-recurring-change">

                {workspaceRecurringDelta !== 0 &&
                workspaceRecurringDelta !== Infinity &&
                selectedTeamId &&
                `(${workspaceRecurringDelta < 0 ? '+' : '-'}${Math.abs(workspaceRecurringDelta)})`}

              </span>
              <span data-testid="workspace-recurring-balance">
                {`${workspaceRecurringBalance} Credits`}
              </span>
            </Text>
          </div>
        </div>
        <div className="detailed-view__block__item">
          <Text noMargin>This Monthly Only</Text>
          <div>
            <Text heading5 noMargin>
              <span
                className={cx({
                  'detailed-view__block__item__added-credits': usageOfThisMonthOnlyCredits <= 0,
                  'detailed-view__block__item__subtracted-credits': usageOfThisMonthOnlyCredits > 0
                })}
                data-testid="workspace-this-month-only-change">

                {usageOfThisMonthOnlyCredits !== 0 &&
                !selectedTeamId &&
                `(${usageOfThisMonthOnlyCredits < 0 ? '+' : '-'}${Math.abs(usageOfThisMonthOnlyCredits)})`}

                {workspaceThisMonthOnlyDelta !== 0 &&
                selectedTeamId &&
                `(${workspaceThisMonthOnlyDelta < 0 ? '+' : '-'}${Math.abs(workspaceThisMonthOnlyDelta)})`}

              </span>
              <span data-testid="workspace-this-month-only-balance">
                {`${workspaceThisMonthOnlyBalance} Credits`}
              </span>
            </Text>
          </div>
        </div>
      </div>

      <div className="detailed-view__block">
        <div>
          <Text heading4 noMargin>{`${selectedTeamId ? 'Current Team' : 'All Teams'} Balance`}</Text>
          <Text label>Renewable and temporary credits within all our teams</Text>
        </div>
        <div className="detailed-view__block__item">
          <Text noMargin>Recurring Monthly</Text>
          <div>
            <Text heading5 noMargin>
              {selectedTeamId ?

              <>
                    <span
                  className={cx({
                    'detailed-view__block__item__added-credits': usageOfWorkspaceCredits > 0,
                    'detailed-view__block__item__subtracted-credits': usageOfWorkspaceCredits <= 0
                  })}>

                      {usageOfWorkspaceCredits !== 0 ?
                  `(${usageOfWorkspaceCredits > 0 ? '+' : '-'}${Math.abs(usageOfWorkspaceCredits)})` :
                  null}

                    </span>
                    {`${originalRecurringMonthly} Credits`}
                  </> :

              `${allTeamsBalances.allCredits -
              allTeamsBalances.allThisMonthOnlyCreditBalance -
              allTeamsBalances.allThisMonthOnlyRecurringBalance
              } Credits`}

            </Text>
          </div>
        </div>
        <div className="detailed-view__block__item">
          <Text noMargin>This Monthly Only</Text>
          <div>
            <Text heading5 noMargin>
              {selectedTeamId ?

              <>
                    <span
                  className={cx({
                    'detailed-view__block__item__added-credits': usageOfThisMonthOnlyCredits > 0,
                    'detailed-view__block__item__subtracted-credits': usageOfThisMonthOnlyCredits <= 0
                  })}>

                      {usageOfThisMonthOnlyCredits !== 0 && usageOfThisMonthOnlyCredits > 0 && `(+${usageOfThisMonthOnlyCredits})`}
                      {usageOfThisMonthOnlyCredits !== 0 && usageOfThisMonthOnlyCredits <= 0 && `(${usageOfThisMonthOnlyCredits})`}
                    </span>
                    {`${originalThisMonthOnly} Credits`}
                  </> :

              `${
              allTeamsBalances.allThisMonthOnlyCreditBalance +
              allTeamsBalances.allThisMonthOnlyRecurringBalance
              } Credits`}

            </Text>
          </div>
        </div>
      </div>

      <div className="detailed-view__block">
        <div>
          <Text heading4 noMargin>All Time Flex Credits</Text>
          <Text label>Remaining credits purchased out of your subscription</Text>
        </div>
        <div className="detailed-view__block__item">
          <Text noMargin>Workspace</Text>
          <div>
            <Text heading5 noMargin>
              <span
                className={cx({
                  'detailed-view__block__item__added-credits': usageOfTopUpCredits <= 0,
                  'detailed-view__block__item__subtracted-credits': usageOfTopUpCredits > 0
                })}>

                {usageOfTopUpCredits !== 0 &&
                !selectedTeamId &&
                `(${usageOfTopUpCredits < 0 ? '+' : '-'}${Math.abs(usageOfTopUpCredits)})`}

                {usageOfTopUpCredits !== 0 &&
                selectedTeamId &&
                `(${usageOfTopUpCredits > 0 ? '-' : '+'}${Math.abs(usageOfTopUpCredits)})`}

              </span>
              {`${workspaceTopUpCredits} Credits`}
            </Text>
          </div>
        </div>
        <div className="detailed-view__block__item">
          <Text noMargin>{selectedTeamId ? 'This Team' : 'All Teams'}</Text>
          <div>
            <Text heading5 noMargin>
              {selectedTeamId ?

              <>
                    <span
                  className={cx({
                    'detailed-view__block__item__added-credits': usageOfTopUpCredits > 0,
                    'detailed-view__block__item__subtracted-credits': usageOfTopUpCredits <= 0
                  })}>

                      {usageOfTopUpCredits !== 0 && usageOfTopUpCredits > 0 && `(+${usageOfTopUpCredits})`}
                      {usageOfTopUpCredits !== 0 && usageOfTopUpCredits <= 0 && `(${usageOfTopUpCredits})`}
                    </span>
                    {`${originalTopUp} Credits`}
                  </> :

              `${allTeamsBalances.allTopUpCredits} Credits`}
            </Text>
          </div>
        </div>
      </div>

      <div className="detailed-view__block">
        <div className="detailed-view__block__item">
          <Text heading4 noMargin>Credit Advance Owed</Text>
          <Text heading4 noMargin className="detailed-view__block__item__buffer-credits">
            {`
              ${
            bufferOwed || 0
            }
              of ${wsBufferLimit} Credits
            `}
          </Text>
        </div>
        <Text label>Advance Credits consumed across the workspace and all teams</Text>
      </div>
    </div>);

}

export default InternalCreditsSummary;